import styled from 'styled-components';
import {
  spacer16,
  spacer20,
  spacer24,
  spacer48,
  spacer64,
} from '@spotify-internal/encore-foundation';

export const HSpacer16 = styled.div`
  min-width: ${spacer16};
`;

export const HSpacer64 = styled.div`
  min-width: ${spacer64};
`;

export const VSpacer20 = styled.div`
  min-height: ${spacer20};
`;

export const VSpacer24 = styled.div`
  min-height: ${spacer24};
`;

export const VSpacer48 = styled.div`
  min-height: ${spacer48};
`;
